export default {
  menu: {
    list: 'AI Agent列表',
    edit: '编辑AI Agent'
  },
  title: {
    aiAgentManagement: 'AI Agent管理'
  },
  label: {
    companyName: '公司名称',
    agentName: 'Agent名称',
    modelName: '模型名称',
    version: '版本',
    updateTime: '更新时间',
    temperature: '温度',
    prompt: '提示词',
    agentDescription: 'Agent描述'
  }
}
